import PropTypes from 'prop-types';

const QuickStats = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-4 mt-10'}>
      <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:p-8 md:p-4 p-4 max-w-7xl text-center justify-center items-center'}>
        {data.map((stat, index) => (
          <div
            key={index}
            className={'border-2 border-secondary-300 rounded-full px-8 py-3'}
          >
            <h2 className={'text-2xl font-bold mb-4 text-secondary-300'}>{stat.title}</h2>
            <p className={'text-lg'}>{stat.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

QuickStats.propTypes = {
  data: PropTypes.shape,
};

export default QuickStats;
